import { render } from "./Activity.vue?vue&type=template&id=733adc3f"
import script from "./Activity.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/Activity.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "733adc3f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('733adc3f', __exports__)) {
    api.reload('733adc3f', __exports__)
  }
  
  module.hot.accept("./Activity.vue?vue&type=template&id=733adc3f", () => {
    api.rerender('733adc3f', render)
  })

}


export default __exports__